import { useState, useEffect } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const videos = [
  {
    title: 'META66元宇宙生态全景介绍',
    description: '深度解析META66元宇宙生态系统的核心架构、技术路线与未来发展规划，带你全面了解元宇宙的底层逻辑与商业价值。',
    duration: 'PT3M28S', durationDisplay: '3:28', views: '128万', uploadDate: '2024-11-15',
    thumbnailUrl: 'https://public.readdy.ai/ai/img_res/ac6a1472fd1df8ab3069acf8f8d566ba.jpg',
    youtubeId: 'eqR_IHqFMiI', tags: ['元宇宙', 'META66', '数字文明'],
  },
  {
    title: '6G网络如何重塑元宇宙体验',
    description: '6G太赫兹通信技术深度解析：从毫米波到太赫兹，从1Gbps到1Tbps，6G如何为元宇宙提供实时全息通信的基础设施支撑。',
    duration: 'PT5M14S', durationDisplay: '5:14', views: '86万', uploadDate: '2024-10-22',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=6G%20network%20signal%20tower%20glowing%20colorful%20neon%20futuristic%20technology%20dark%20background%20cinematic%20sci-fi%20digital%20doodle%20art%20style%20vibrant%20yellow%20pink&width=640&height=360&seq=vid-cover-doodle-2&orientation=landscape',
    youtubeId: 'G-ZcAn_QLHM', tags: ['6G', '通信技术', '元宇宙基础设施'],
  },
  {
    title: 'Web5.0去中心化协议深度解析',
    description: 'Web5.0数字主权网络的底层逻辑：AI驱动的去中心化协议如何重构互联网价值体系，DID数字身份与数据主权的技术实现路径，以及对传统互联网巨头的颠覆性影响。',
    duration: 'PT8M02S', durationDisplay: '8:02', views: '64万', uploadDate: '2024-09-18',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=web5%20decentralized%20blockchain%20network%20nodes%20glowing%20colorful%20connections%20dark%20background%20futuristic%20technology%20cinematic%20doodle%20art%20style%20vibrant%20cyan&width=640&height=360&seq=vid-cover-doodle-3b&orientation=landscape',
    youtubeId: 'ceGTgqypwnQ', tags: ['Web5.0', '区块链', '去中心化'],
  },
  {
    title: 'XR沉浸体验：虚实融合的未来',
    description: 'VR/AR/MR/XR技术全景解析：从头显设备到裸眼3D，从手势交互到脑机接口，沉浸式体验技术的演进路径与元宇宙应用场景。',
    duration: 'PT4M45S', durationDisplay: '4:45', views: '92万', uploadDate: '2024-08-30',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=XR%20mixed%20reality%20virtual%20augmented%20holographic%20experience%20colorful%20neon%20glow%20dark%20background%20futuristic%20sci-fi%20cinematic%20doodle%20art%20style%20vibrant%20pink%20cyan&width=640&height=360&seq=vid-cover-doodle-4&orientation=landscape',
    youtubeId: 'vYqMPIZjRtg', tags: ['XR', 'VR', 'AR', '沉浸体验'],
  },
  {
    title: '宇树科技H1机器人：人形机器人的里程碑',
    description: '深度解析宇树科技H1/G1人形机器人的技术突破：后空翻、街舞、武术等高难度动作背后的控制算法、传感器融合与AI决策系统，以及人形机器人走向大众的路线图。',
    duration: 'PT6M33S', durationDisplay: '6:33', views: '155万', uploadDate: '2025-03-14',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Unitree%20humanoid%20robot%20backflip%20street%20dance%20martial%20arts%20advanced%20AI%20technology%20dark%20background%20cinematic%20neon%20glow%20futuristic%20doodle%20art%20style%20vibrant%20orange&width=640&height=360&seq=vid-cover-unitree-1&orientation=landscape',
    youtubeId: 'mEJkQ-oxnUY', tags: ['人形机器人', '宇树科技', 'AI'],
  },
  {
    title: '脑机接口：意念操控元宇宙的技术路径',
    description: 'Neuralink、Synchron等脑机接口公司的技术路线对比，非侵入式BCI的信号采集原理，以及脑机接口如何在2028年前实现元宇宙意念操控的完整技术路径。',
    duration: 'PT7M19S', durationDisplay: '7:19', views: '73万', uploadDate: '2025-01-20',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=brain%20computer%20interface%20neural%20link%20mind%20control%20metaverse%20purple%20neon%20glow%20neural%20network%20signals%20dark%20background%20futuristic%20cinematic%20doodle%20art%20style%20vibrant&width=640&height=360&seq=vid-cover-bci-1&orientation=landscape',
    youtubeId: 'AZr_PkjB-pE', tags: ['脑机接口', 'BCI', '神经科技'],
  },
  {
    title: 'AGI降临：超级智能将如何重塑人类文明',
    description: '从GPT-6到AGI的技术跨越路径，超级智能（ASI）出现的时间预测，以及AI与人类意识深度融合后的文明形态——这不是科幻，而是2030年代最可能发生的现实。',
    duration: 'PT13M08S', durationDisplay: '13:08', views: '201万', uploadDate: '2026-01-15',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=AGI%20artificial%20general%20intelligence%20superintelligence%20human%20civilization%20transformation%20golden%20neon%20glow%20brain%20digital%20mind%20futuristic%20dark%20background%20cinematic%20doodle%20art%20style%20vibrant&width=640&height=360&seq=vid-cover-agi-1&orientation=landscape',
    youtubeId: 'AaTRHFaaPG8', tags: ['AGI', 'AI', '文明变革'],
  },
  {
    title: '火星移民：人类成为多星球物种的技术路线',
    description: 'SpaceX星舰、NASA阿尔忒弥斯计划与中国载人登月工程的技术对比，火星基地建设的工程挑战，以及元宇宙如何在火星移民中扮演关键角色——从训练模拟到远程协作。',
    duration: 'PT11M22S', durationDisplay: '11:22', views: '89万', uploadDate: '2025-04-01',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Mars%20colony%20habitat%20dome%20red%20planet%20earth%20view%20space%20settlement%20futuristic%20technology%20cinematic%20neon%20glow%20doodle%20art%20style%20vibrant%20orange&width=640&height=360&seq=vid-cover-mars-1&orientation=landscape',
    youtubeId: 'zA4S_OLbdHo', tags: ['火星', '太空探索', '人类移民'],
  },
  {
    title: '量子计算如何颠覆元宇宙安全体系',
    description: '量子密钥分发（QKD）与后量子密码学：在量子计算威胁下，如何构建元宇宙的安全基础设施，保护数字资产与用户隐私，以及量子互联网的商用化时间表。',
    duration: 'PT9M45S', durationDisplay: '9:45', views: '48万', uploadDate: '2025-02-08',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=quantum%20computing%20security%20encryption%20particles%20glowing%20colorful%20dark%20background%20futuristic%20technology%20sci-fi%20cinematic%20doodle%20art%20style%20vibrant%20green%20yellow&width=640&height=360&seq=vid-cover-quantum-1&orientation=landscape',
    youtubeId: 'AZr_PkjB-pE', tags: ['量子计算', '网络安全', '加密技术'],
  },
];

export default function VideoSection() {
  const [playing, setPlaying] = useState<number | null>(null);
  const [showAll, setShowAll] = useState(false);
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: featuredRef, isVisible: featuredVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation({ threshold: 0.05 });

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://meta66.cn';
    const videoSchemas = videos.map((v) => ({
      '@context': 'https://schema.org', '@type': 'VideoObject',
      name: v.title, description: v.description, thumbnailUrl: v.thumbnailUrl,
      uploadDate: v.uploadDate, duration: v.duration,
      contentUrl: `https://www.youtube.com/watch?v=${v.youtubeId}`,
      embedUrl: `https://www.youtube.com/embed/${v.youtubeId}`,
      publisher: { '@type': 'Organization', name: 'META66', url: siteUrl },
      keywords: v.tags.join(', '), inLanguage: 'zh-CN', isFamilyFriendly: true,
    }));
    const existingScript = document.getElementById('video-schema-jsonld');
    if (existingScript) existingScript.remove();
    const script = document.createElement('script');
    script.id = 'video-schema-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(videoSchemas);
    document.head.appendChild(script);
    return () => { const s = document.getElementById('video-schema-jsonld'); if (s) s.remove(); };
  }, []);

  const displayedVideos = showAll ? videos.slice(1) : videos.slice(1, 7);
  const cardColors = ['#FFD700', '#00FFCC', '#FF6B9D', '#00FF88', '#A855F7', '#FF6B35', '#00FFCC', '#FFD700'];

  return (
    <section id="videos" className="relative py-24 md:py-32 bg-[#020810] overflow-hidden doodle-dots-bg">
      <div className="doodle-splat splat-pink absolute top-20 left-10 w-48 h-48" />
      <div className="doodle-splat splat-yellow absolute bottom-20 right-10 w-56 h-56" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-16 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="section-badge mb-6 mx-auto w-fit">
            <i className="ri-play-circle-line" />
            Video Center · 影像志
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            元宇宙<span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B9D] to-[#FFD700]"> 影像志</span>
          </h2>
          <p className="text-white/40 text-base max-w-2xl mx-auto leading-relaxed">
            深度纪录片 · 前沿技术解析 · 宇树机器人 · AGI · 脑机接口 · 火星移民——用影像记录数字文明的每一次跃迁
          </p>
          <div className="doodle-wave-divider mt-6 opacity-50" />
        </div>

        {/* Featured Video */}
        <div ref={featuredRef as React.RefObject<HTMLDivElement>}
          className={`relative rounded-2xl overflow-hidden border border-white/10 mb-8 cursor-pointer group transition-all duration-700 delay-150 doodle-hover-card ${featuredVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          onClick={() => setPlaying(0)}>
          <div className="relative h-[300px] md:h-[420px]">
            <img src={videos[0].thumbnailUrl} alt={videos[0].title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 flex items-center justify-center border-2 border-[#FF6B9D] group-hover:scale-110 transition-transform duration-300"
                style={{ backgroundColor: 'rgba(255,107,157,0.2)', borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%', boxShadow: '0 0 30px rgba(255,107,157,0.4)' }}>
                <i className="ri-play-fill text-[#FF6B9D] text-4xl" />
              </div>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <span className="px-3 py-1 text-[#FF6B9D] text-xs font-semibold mb-2 inline-block border border-[#FF6B9D]/40"
                style={{ backgroundColor: 'rgba(255,107,157,0.15)', borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%' }}>精选推荐</span>
              <h3 className="text-white text-xl md:text-2xl font-bold">{videos[0].title}</h3>
              <p className="text-white/60 text-sm mt-1 line-clamp-2">{videos[0].description}</p>
              <div className="flex items-center gap-4 mt-2">
                <span className="text-white/40 text-sm"><i className="ri-time-line mr-1" />{videos[0].durationDisplay}</span>
                <span className="text-white/40 text-sm"><i className="ri-eye-line mr-1" />{videos[0].views}次播放</span>
                <div className="flex gap-1 ml-auto">
                  {videos[0].tags.map((t) => (
                    <span key={t} className="px-2 py-0.5 text-xs text-white/40 border border-white/10"
                      style={{ borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%' }}>{t}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Video Grid */}
        <div ref={gridRef as React.RefObject<HTMLDivElement>}
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 transition-all duration-700 delay-200 ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {displayedVideos.map((v, i) => {
            const c = cardColors[i % cardColors.length];
            return (
              <div key={v.title}
                className="group rounded-2xl overflow-hidden border border-white/8 hover:border-white/20 transition-all duration-300 cursor-pointer bg-[#020810] doodle-hover-card hover:-translate-y-1"
                onClick={() => setPlaying(videos.indexOf(v))}>
                <div className="relative h-44 overflow-hidden">
                  <img src={v.thumbnailUrl} alt={v.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-12 h-12 flex items-center justify-center border opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                      style={{ backgroundColor: `${c}20`, borderColor: `${c}80`, borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%' }}>
                      <i className="ri-play-fill text-xl" style={{ color: c }} />
                    </div>
                  </div>
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white/70 text-xs">{v.durationDisplay}</span>
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 text-xs font-semibold"
                      style={{ backgroundColor: `${c}20`, color: c, borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%', border: `1px solid ${c}40` }}>
                      {v.tags[0]}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-white/85 text-sm font-semibold leading-snug line-clamp-2 group-hover:text-white transition-colors duration-200">{v.title}</p>
                  <p className="text-white/40 text-xs mt-1.5 line-clamp-2 leading-relaxed">{v.description}</p>
                  <div className="flex items-center justify-between mt-3">
                    <p className="text-white/30 text-xs"><i className="ri-eye-line mr-1" />{v.views}次播放</p>
                    <p className="text-white/20 text-xs">{v.uploadDate}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Show More */}
        {!showAll && videos.length > 7 && (
          <div className="flex justify-center mt-8">
            <button onClick={() => setShowAll(true)}
              className="flex items-center gap-2 px-8 py-3 text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap rounded-full hover:scale-105 doodle-hover-card"
              style={{ border: '1.5px dashed rgba(255,107,157,0.4)', color: 'rgba(255,107,157,0.8)', background: 'rgba(255,107,157,0.06)' }}>
              <i className="ri-arrow-down-line" />
              查看更多影像志 ({videos.length - 7} 部)
            </button>
          </div>
        )}
      </div>

      {/* Video Modal */}
      {playing !== null && (
        <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setPlaying(null)}>
          <div className="relative w-full max-w-4xl aspect-video bg-black rounded-2xl overflow-hidden border border-[#FF6B9D]/30"
            onClick={(e) => e.stopPropagation()}>
            <iframe className="w-full h-full"
              src={`https://www.youtube.com/embed/${videos[playing].youtubeId}?autoplay=1&rel=0&modestbranding=1`}
              title={videos[playing].title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen />
            <button onClick={() => setPlaying(null)}
              className="absolute top-4 right-4 z-20 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors cursor-pointer">
              <i className="ri-close-line" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
